import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';

import FrLoading from '../FrLoading'
import api from '../../services/api'
import FrTableReg from '../FrTableReg'
import './index.css';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: 15,
    marginLeft: 0,
    minWidth: 345,
    '&:first-child': {
      marginLeft: 15,
    },
  }
})

function TableDetail(props) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const classes = useStyles();

  const columns = [{ id: 'fk_ctr', numeric: false, label: 'Cód.Ctr', align: 'left', minWidth: 50 },
  { id: 'nomecli', numeric: false, label: 'Cliente', align: 'left', minWidth: 100 },
  { id: 'data', date: true, numeric: false, label: 'Data', align: 'left', minWidth: 50 },
  { id: 'formatValor', numeric: false, label: 'Valor', align: 'left', minWidth: 50 },
  { id: 'cod_ocorrencia', numeric: false, label: 'Cód.Retorno', align: 'left', minWidth: 50 },
  { id: 'motivo', numeric: false, label: 'Motivo', align: 'left', minWidth: 150 },

  ]


  useEffect(() => {
    const fetchData = async () => {
      if (props.isOpen) {
        setLoading(true)
        api.get('/retornos/itens?pk_ret=' + props.detail.pk_ret).then(r => {
          setData(r.data)
          setLoading(false)
        })
      }
    }

    fetchData()
  }, [props.isOpen])

  if (loading) {
    return (
      <>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={props.isOpen} timeout="auto" unmountOnExit>
            <Box margin={3} >
              <FrLoading text="Buscando dados..." />
            </Box>
          </Collapse>
        </TableCell>
      </>
    )
  } else if (data.length > 0) {
    return (
      <>

        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={props.isOpen} timeout="auto" unmountOnExit>

            <FrTableReg readonly={true} detail regName="" columns={columns} searched={false} codeName="display" page={''} data={data} />

          </Collapse>
        </TableCell>
      </>
    )
  } else {
    return (
      <>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={props.isOpen} timeout="auto" unmountOnExit>
            <Box margin={3}>
              Não há registros para detalhar
            </Box>
          </Collapse>
        </TableCell>
      </>
    )
  }

}

export default TableDetail;